module.exports = __webpack_public_path__ + "media/images/face-fae2199701875006126b2d01b2454194.svg";